// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2QXFI","footer":"ReportModalFilter_footer__91eiU"};